/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(
    inboxId,
    botId,
    functionId = null,
    { scheduleEnabled, schedule } = {}
  ) {
    const payload = { agent_bot: botId };
    if (functionId !== undefined && functionId !== null) {
      payload.agent_bot_function = functionId;
    } else if (botId === null) {
      payload.agent_bot_function = null;
    }
    if (scheduleEnabled !== undefined) {
      payload.schedule_enabled = scheduleEnabled;
    }
    if (schedule !== undefined) {
      payload.schedule = schedule;
    }
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, payload);
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  getAgentBotExclusions(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot_exclusions`);
  }

  addAgentBotExclusion(inboxId, contactId) {
    return axios.post(`${this.url}/${inboxId}/agent_bot_exclusions`, {
      contact_id: contactId,
    });
  }

  removeAgentBotExclusion(inboxId, contactId) {
    return axios.delete(
      `${this.url}/${inboxId}/agent_bot_exclusions/${contactId}`
    );
  }
}

export default new Inboxes();
